const themes = {
  palette: {
    primary: {
      main: "#C5A572",
      contrastText: "#fff",
    },
    secondary: {
      main: "#221F1F",
    },
    tertiary: { main: "#67788B" },
    neutral: { main: "#FFFFFF" },
    neutralVariant: { main: "#F5F3EB" },
    info: { main: "#0968f6" },
    success: { main: "#059669", dark: "#047854" },
    warning: { main: "#FF9900", dark: "#CC7A00" },
    error: { main: "#FF0000", dark: "#B80000" },
    accent: { main: "#2F5FA7", dark: "#234A84", light: "#E0EAF8" },
    text: {
      primary: "#000000DE",
      secondary: "#4F4F4F",
      disabled: "#9E9E9E",
    },
    customColor: {
      name: "Custom Color 1",
      color: "#E6E6DF",
      description: "",
      harmonized: false,
    },
    customColor2: {
      name: "Custom Color 2",
      color: "#C7E2FE",
      description: "",
      harmonized: false,
    },
    customColor3: {
      name: "Custom Color 3",
      color: "#A7C4B5",
      description: "",
      harmonized: false,
    },
    customColor4: {
      name: "Custom Color 4",
      color: "#FFF3CB",
      description: "",
      harmonized: false,
    },
    customColor5: {
      main: "#ced4da",
    },
    customColor6: {
      main: "#adb5bd",
    },
    hoverButton: {
      border: "#dadce0",
      background: "#f8f9fa",
    },
  },
  typography: {
    fontFamily: "Montserrat,sans-serif",
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          "&.MuiButton-root": {
            textTransform: "none",
          },
        },
      },
    },
    MuiToggleButton: {
      styleOverrides: {
        root: {
          "&.MuiToggleButton-root": {
            textTransform: "none",
          },
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          "&.MuiTab-root": {
            textTransform: "none",
            "&:hover": {
              backgroundColor: "rgba(0,0,0,0.04)",
            },
          },
        },
      },
    },
    MuiLink: {
      styleOverrides: {
        root: {
          "&.MuiLink-root": {
            color: "#000000",
          },
        },
      },
    },
  },
};

export default themes;
